import {
  ListViewResultIcon,
  ListViewResultMeta,
  ListViewResultRow,
  ListViewResultSection,
  ListViewResultTitle,
  SearchResultItem,
  StyledSearchResultsItemTitle,
} from "../../../../../share/searchResults";
import { useActions } from "../../../../../hooks/useActions";
import { MapObject } from "../../../../../models/MapObject";
import useSearchParams from "../../../../../hooks/useSearchParams";
import ImageFinder from "../../../../../share/ImageFinder/ImageFinder";
import { useTypedSelector } from "../../../../../hooks/useTypedSelector";
import { formatSearchResultTitle } from "../../../../../util/stringUtil";
import useMobileScreen from "../../../../../hooks/useMobileScreen";
import { breakpoints } from "../../../../../constants";

type Props = {
  mapObject: MapObject;
};

const MainSearchResultsItem: React.FC<Props> = ({ mapObject }) => {
  const { setCurrentMarker } = useActions();
  const { setSearchParam } = useSearchParams();
  const { subscribe } = useTypedSelector((state) => state.currentAccount);
  const isListViewActive = useTypedSelector(
    (state) => state.mapInterface.isListViewActive
  );
  const isMobile = useMobileScreen(breakpoints.medium);
  const shouldRenderListView = isListViewActive && !isMobile;

  const handleClick = () => {
    const hashId = mapObject.hash_id || mapObject.aimap_id;
    setSearchParam("hash_id", hashId);
  };

  function renderObjectSquare() {
    if (subscribe?.permissions.non_available_field?.includes("object_square")) {
      return "";
    }
    if (
      mapObject.object_square &&
      mapObject.object_square !== "0" &&
      mapObject.object_square !== "null"
    ) {
      return "· " + mapObject.object_square + " м²";
    }
    return "";
  }

  const objectSquare = renderObjectSquare();
  const squareText = objectSquare ? objectSquare.replace(/^·\s*/, "") : "";
  const consequenceClass = mapObject.consequence_class || mapObject.type;
  const consequenceLabel = consequenceClass ? `СС ${consequenceClass}` : "";
  const classificationDetails = [consequenceLabel, squareText]
    .filter(Boolean)
    .join(" · ");

  return (
    <SearchResultItem
      hashId={mapObject.hash_id}
      onMouseEnter={() =>
        setCurrentMarker({
          lon: +mapObject.lon,
          lat: +mapObject.lat,
        })
      }
      onMouseLeave={() => setCurrentMarker({ lon: 0, lat: 0 })}
      onClick={handleClick}
    >
      {shouldRenderListView ? (
        <ListViewResultRow>
          <ListViewResultIcon>
            <ImageFinder object={mapObject} />
          </ListViewResultIcon>
          <ListViewResultSection flex="2 1 320px">
            <ListViewResultTitle>
              {formatSearchResultTitle(mapObject.name)}
            </ListViewResultTitle>
            <ListViewResultMeta>
              {mapObject.aimap_classifier || "—"}
            </ListViewResultMeta>
          </ListViewResultSection>
          <ListViewResultSection flex="1 1 220px">
            <ListViewResultMeta>
              {mapObject.construction_type || "—"}
            </ListViewResultMeta>
          </ListViewResultSection>
          <ListViewResultSection flex="1 1 200px">
            <ListViewResultMeta>
              {classificationDetails || "—"}
            </ListViewResultMeta>
          </ListViewResultSection>
        </ListViewResultRow>
      ) : (
        <>
          <ImageFinder object={mapObject} />
          <StyledSearchResultsItemTitle>
            {formatSearchResultTitle(mapObject.name)}
          </StyledSearchResultsItemTitle>
          <p>{mapObject.aimap_classifier}</p>
          <p>
            {mapObject.construction_type} &middot; СС{" "}
            {(mapObject.consequence_class || mapObject.type) + " "}
            {objectSquare}
          </p>
        </>
      )}
    </SearchResultItem>
  );
};

export default MainSearchResultsItem;
